import React from 'react';
import { getThemeColors } from '../../../../lib/theme';
import { formatTime } from '../../../../lib/dateFormat';
import type { DashboardData } from '../types';

interface TodayWidgetProps {
  mode: 'full' | 'summary';
  dark: boolean;
  data: DashboardData | null;
  tr: (k: string) => string;
}

function eventTime(iso: string, allDay: boolean, tr: (k: string) => string): string {
  if (allDay) return tr('dashboard.widget.today.all_day');
  return formatTime(iso);
}

export function TodayWidget({ mode, dark, data, tr }: TodayWidgetProps) {
  const t = getThemeColors(dark);
  const events = data?.todayEvents ?? [];
  const shown = mode === 'summary' ? events.slice(0, 2) : events;

  if (data && events.length === 0) {
    return (
      <div style={{ fontSize: 12, color: t.muted, padding: '8px 0' }}>
        {tr('dashboard.widget.today.empty')}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {shown.map(e => {
        const color = e.category?.color || '#0ba5ec';
        return (
          <div key={e.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '6px 0' }}>
            <div style={{ fontSize: 11, color: t.muted, fontWeight: 600, width: 44, flexShrink: 0, paddingTop: 2 }}>
              {eventTime(e.start_at, e.all_day, tr)}
            </div>
            <div style={{ width: 3, background: color, borderRadius: 2, alignSelf: 'stretch', flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 500, color: t.heading }}>{e.title}</div>
              {e.category?.name && (
                <div style={{ fontSize: 10, color: t.muted, marginTop: 1 }}>{e.category.name}</div>
              )}
            </div>
          </div>
        );
      })}
      {!data && <div style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.loading')}</div>}
    </div>
  );
}
